import { render, staticRenderFns } from "./SlideVerify.vue?vue&type=template&id=bca6775c"
import script from "./SlideVerify.vue?vue&type=script&lang=ts"
export * from "./SlideVerify.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports